import React from 'react';

const SalesIcon = ({ active }) => {
  return (
    <svg
      id="money_black_24dp_1_"
      data-name="money_black_24dp (1)"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path id="Path_6128" data-name="Path 6128" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_6129"
        data-name="Path 6129"
        d="M15,16h3a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1v6A1,1,0,0,0,15,16Zm1-6h1v4H16ZM9,16h3a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H9A1,1,0,0,0,8,9v6A1,1,0,0,0,9,16Zm1-6h1v4H10ZM5,8H7v8H5ZM2,4V20H22V4ZM20,18H4V6H20Z"
        fill={active ? '#58B9C1' : '#ededed'}
      />
    </svg>
  );
};

export default SalesIcon;
